module.exports = __webpack_public_path__ + "a34df51b9b8ea9bd63ef86636964d8e9.jpg";